import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';

const actions = {
  // async getReports({ commit }, { companyId } = {}) {
  async getReports({ commit }) {
    try {
      const queryParams = {
        pagination: {
          limit: 9999999,
          offset: 0,
        },
        sorting: [
          {
            column: 'orderId',
            order: 'desc',
          },
        ],
        filters: {
          employee: [],
          pmUserIds: [],
          billingAddress: [],
          shippingAddress: [],
          orderStatus: [],
          costumers: [],
          payMethod: [],
          promoCodes: [],
          conciergeId: [],
          dates: [],
        },
      };

      const params = new URLSearchParams({
        query: JSON.stringify(queryParams),
      });

      const response = await apiCall({
        type: 'GET',
        url: `${URLS.reports}?${params.toString()}`,
        isToken: true,
      });

      const {
        data: {
          data: {
            data: reportsArray,
            meta,
          },
        },
      } = response;

      commit('GET_REPORTS_SUCCESS', reportsArray);
      commit('SET_REPORTS_TOTAL', Number(meta.count));
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
};

export default actions;
